// Import: Middleware Action & Custom Types
import {
    CLEAN_GET_SALES_WEEKLY,
    CLEAN_GET_SALES_WEEKLY_ERROR,
} from "_models/redux/types";

// Action function
export const cleanGetSalesWeeklyAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            payload: undefined,
            type: CLEAN_GET_SALES_WEEKLY,
        });
    } catch (e) {
        dispatch({
            payload: undefined,
            type: CLEAN_GET_SALES_WEEKLY_ERROR,
        });
    }
};
